import {
  Button,
  MessageBar,
  MessageBarBody,
  Text,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    maxWidth: "720px",
    display: "flex",
    flexDirection: "column",
    rowGap: "16px",
    ...shorthands.padding("8px"),
  },
  actions: { display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "8px" },
});

export function SuccessScreen({
  documentUrl,
  onNewBrief,
}: {
  documentUrl: string | null;
  onNewBrief: () => void;
}) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <Text as="h1" size={700} weight="semibold">
        🎉 Brief généré avec succès
      </Text>
      <MessageBar intent="success">
        <MessageBarBody>
          Le document Word a été créé et le mail de confirmation a été envoyé.
        </MessageBarBody>
      </MessageBar>
      <MessageBar intent="info">
        <MessageBarBody>
          📬 Vous recevrez votre brief par mail dans quelques instants. L'équipe Kontent Factory
          prend le relais !
        </MessageBarBody>
      </MessageBar>

      <div className={styles.actions}>
        {documentUrl && (
          <Button as="a" appearance="primary" href={documentUrl} target="_blank" rel="noreferrer">
            Ouvrir le document
          </Button>
        )}
        <Button appearance="secondary" onClick={onNewBrief}>
          ➕ Créer un autre brief
        </Button>
      </div>
    </div>
  );
}
